import { render, staticRenderFns } from "./userCard.vue?vue&type=template&id=4fffaf4d&scoped=true&"
import script from "./userCard.vue?vue&type=script&lang=js&"
export * from "./userCard.vue?vue&type=script&lang=js&"
import style0 from "./userCard.vue?vue&type=style&index=0&id=4fffaf4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fffaf4d",
  null
  
)

export default component.exports